/**
 * Utility function to conditionally join class names
 * Lightweight alternative to clsx/classnames
 */
export function cn(...classes: (string | boolean | undefined | null)[]): string {
  return classes.filter(Boolean).join(' ');
}

export default cn;
